export default __webpack_public_path__ + "static/media/ag-spaceship.7f55ea9a.png";